import PropTypes from 'prop-types';
import React from 'react';
import Markdown from '../../../components/Markdown';
import { AdditionalVideoWrapper, TitleWrapper, Description } from './AdditionalVideo.style';
import Video from '../../../components/BrightcoveVideo';

const AdditionalVideo = ({ data }) => (
  <AdditionalVideoWrapper>
    <TitleWrapper>{data.title}</TitleWrapper>
    <Video {...data.video} />
    <Markdown src={data.description} Component={Description} />
  </AdditionalVideoWrapper>
);

AdditionalVideo.defaultProps = {
  data: {},
};
AdditionalVideo.propTypes = {
  data: PropTypes.shape(),
};

export default AdditionalVideo;



// WEBPACK FOOTER //
// ./src/pages/RangePage/AdditionalVideo/AdditionalVideo.js